/**
 * Firebase Configuration
 * Used for Firebase Phone Authentication on web
 */

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

// Firebase configuration - Web App "OnRecord Web" (project: onrecord-ba826)
// Unified with mobile app Firebase project for consistent authentication
const firebaseConfig = {
  apiKey: "AIzaSyBDNMI5brC3kOBfTkEn_YPL1wAvfC-qZNU",
  authDomain: "onrecord-ba826.firebaseapp.com",
  projectId: "onrecord-ba826",
  storageBucket: "onrecord-ba826.firebasestorage.app",
  messagingSenderId: "200674531264",
  appId: "1:200674531264:web:5a1999968d62dbde80da25",
  measurementId: "G-Q8572QBGX9"
};

// Initialize Firebase
let app: FirebaseApp;
let auth: Auth;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);

  console.log('✅ Firebase initialized successfully');
  console.log('Project ID:', firebaseConfig.projectId);
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  throw error;
}

export { app, auth };
export default auth;
